import { AppBox } from "../../../../commons/components";
import { FootballOrganizer } from "../../../../commons/models/football/football-organizer";
import { toTitleCase } from "../../../../commons/utilities/string-utils";

interface OrganizerDeleteProps {
  organizer: FootballOrganizer;
}
export default function OrganizerDelete({ organizer }: OrganizerDeleteProps) {
  return (
    <AppBox displayBlock>
      Do you want to delete <strong>“{toTitleCase(organizer.name)}”</strong> permanently? Once you delete the organizer,
      the action cannot be undone.
    </AppBox>
  );
}
